import { render, staticRenderFns } from "./SuppliesTable.vue?vue&type=template&id=7043a2fa&scoped=true"
import script from "./SuppliesTable.vue?vue&type=script&lang=ts"
export * from "./SuppliesTable.vue?vue&type=script&lang=ts"
import style0 from "./SuppliesTable.vue?vue&type=style&index=0&id=7043a2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043a2fa",
  null
  
)

export default component.exports